module.exports = __webpack_public_path__ + "static/open-source-8845fcfd34f28ed46a898652194f5ed2.png";